import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list"]
  static values = {
    url: String
  }

  connect() {
    this.initDragAndDrop()
  }

  disconnect() {
    this.cleanupDragAndDrop()
  }

  initDragAndDrop() {
    if (!this.hasListTarget) return

    this.listTarget.querySelectorAll(".item-media-card").forEach(card => {
      card.setAttribute("draggable", "true")
      card.addEventListener("dragstart", this.handleDragStart.bind(this))
      card.addEventListener("dragend", this.handleDragEnd.bind(this))
      card.addEventListener("dragover", this.handleDragOver.bind(this))
      card.addEventListener("drop", this.handleDrop.bind(this))
    })
  }

  cleanupDragAndDrop() {
    if (!this.hasListTarget) return

    this.listTarget.querySelectorAll(".item-media-card").forEach(card => {
      card.removeEventListener("dragstart", this.handleDragStart.bind(this))
      card.removeEventListener("dragend", this.handleDragEnd.bind(this))
      card.removeEventListener("dragover", this.handleDragOver.bind(this))
      card.removeEventListener("drop", this.handleDrop.bind(this))
    })
  }

  handleDragStart(event) {
    this.draggedElement = event.currentTarget
    event.currentTarget.classList.add("opacity-50", "scale-95")
    event.dataTransfer.effectAllowed = "move"
    event.dataTransfer.setData("text/plain", event.currentTarget.dataset.id)
  }

  handleDragEnd(event) {
    event.currentTarget.classList.remove("opacity-50", "scale-95")
    this.listTarget.querySelectorAll(".item-media-card").forEach(card => {
      card.classList.remove("border-indigo-500", "border-2")
    })
    this.draggedElement = null
  }

  handleDragOver(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"

    const target = event.currentTarget
    if (target !== this.draggedElement) {
      target.classList.add("border-indigo-500", "border-2")
    }
  }

  handleDrop(event) {
    event.preventDefault()
    const target = event.currentTarget
    target.classList.remove("border-indigo-500", "border-2")

    if (target === this.draggedElement) return

    const allCards = [...this.listTarget.querySelectorAll(".item-media-card")]
    const draggedIndex = allCards.indexOf(this.draggedElement)
    const targetIndex = allCards.indexOf(target)

    if (draggedIndex < targetIndex) {
      target.after(this.draggedElement)
    } else {
      target.before(this.draggedElement)
    }

    this.savePositions()
  }

  setLayout(event) {
    event.preventDefault()
    event.stopPropagation()

    const button = event.currentTarget
    const mediaId = button.dataset.mediaId
    const layout = button.dataset.layout
    const span = layout === "landscape" ? 2 : 1

    // Update button states visually
    const card = document.getElementById(`item_media_${mediaId}`)
    if (card) {
      card.querySelectorAll(".layout-btn").forEach(btn => {
        btn.classList.remove("bg-blue-600", "text-white")
        btn.classList.add("bg-gray-100", "text-gray-600")
      })
      button.classList.remove("bg-gray-100", "text-gray-600")
      button.classList.add("bg-blue-600", "text-white")

      // Update card span data
      card.dataset.span = span

      // Update grid span class
      if (span === 2) {
        card.classList.add("col-span-2")
      } else {
        card.classList.remove("col-span-2")
      }
    }

    this.savePositions()
  }

  async savePositions() {
    const positions = []
    let position = 1

    this.listTarget.querySelectorAll(".item-media-card").forEach(card => {
      positions.push({
        id: parseInt(card.dataset.id),
        position: position,
        grid_column: parseInt(card.dataset.gridColumn) || 1,
        span: parseInt(card.dataset.span) || 1
      })
      position++
    })

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Accept": "application/json"
        },
        body: JSON.stringify({ positions })
      })

      if (!response.ok) {
        console.error("Failed to save positions")
      }
    } catch (error) {
      console.error("Error saving positions:", error)
    }
  }
}
